import { render, staticRenderFns } from "./ASelect.vue?vue&type=template&id=54d25f51"
import script from "./ASelect.vue?vue&type=script&lang=js"
export * from "./ASelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports